<template>
  <div>
    <img class="background-img col-12 cover h100" src="../assets/space.jpg">
    <!-- <img class="background-img col-12 cover h100 flying-body" src="../assets/cls_sideview.png"> -->

    <div class="flex col-12 justify-between">
      <img class="cbx-logo" src="../assets/CQL_logo_kombi.svg">
    </div>

    <div class="login-window box-shadow-big mx-auto bg-color-darkgray rounded-border">
      <div class="pt4 pr3 pl3 pb3">
        <div class="col-12 flex justify-center flex-column">
          <svg class="mx-auto" width="64" height="64" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 12C8.90111 12 8.80444 12.0293 8.72221 12.0843C8.63999 12.1392 8.5759 12.2173 8.53806 12.3087C8.50022 12.4 8.49032 12.5006 8.50961 12.5975C8.5289 12.6945 8.57652 12.7836 8.64645 12.8536C8.71637 12.9235 8.80546 12.9711 8.90245 12.9904C8.99944 13.0097 9.09998 12.9998 9.19134 12.9619C9.2827 12.9241 9.36079 12.86 9.41573 12.7778C9.47068 12.6956 9.5 12.5989 9.5 12.5C9.5 12.3674 9.44732 12.2402 9.35355 12.1464C9.25979 12.0527 9.13261 12 9 12Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 10V5" stroke="white" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="white" stroke-miterlimit="10"/>
          </svg>
          <p class="h2 white bold mx-auto center pb4 pt2">{{$t('logout-session_p_session_beendet')}}</p>
        </div>
      </div>
      <div class="divider">
      </div>
      <div class="bg-color-darkgray pr4 pl4 pt3 pb3 rounded-border-bottom">
        <div class="flex align-middle mx-auto justify-center">
          <p class="p-small regular color-gray">{{$t('logout-session_p_zurueck_zum_logout')}}</p>
          <router-link class="btn btn-primary ml3" :to="'/' + this.$i18n.locale">{{$t('logout-session_btn_login')}}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>



export default {
  name: "LogoutSession",
  data() {
    return {
      debug: false,
    };
  },

  methods: {


  },

};
</script>
<style scoped>
</style>
